import { ErrorHandler, inject } from '@angular/core';
import { Router } from '@angular/router';

export class GlobalErrorHandler implements ErrorHandler {
    private readonly router = inject(Router);

    handleError(error: unknown): void {
        // Log the error for diagnostics
        // eslint-disable-next-line no-console
        console.error('Uncaught exception:', error);

        // Navigate to the error page with a minimal message.
        // Use setTimeout to avoid navigation during change detection.
        try {
            const message = this.getErrorMessage(error);
            setTimeout(() => {
                this.router.navigate(['/error'], { state: { message } });
            }, 0);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error while handling error', e);
        }
    }

    private getErrorMessage(error: unknown): string {
        if (error instanceof Error && error.message) {
            return error.message;
        }

        if (typeof error === 'string' && error.trim()) {
            return error;
        }

        return 'An unexpected error occurred';
    }
}
